import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Terms } from "~/pages/auth/JoinPage";
import { TermsOfUse } from "../../components/policy";
import { PrivacyPolicy } from "../../components/policy";

import { useTranslation } from "react-i18next";

const JoinPolicy = ({ setCurrentStep, setCheckPolicy }) => {
	const navigate = useNavigate();
	const initialState = [
		{
			text : Terms.SERVICE_POL ,
			content : <TermsOfUse /> ,
			checked : false ,
			required : true ,
			
		} ,
	
		{
			text : Terms.PRIVACY_POL ,
			content : <PrivacyPolicy /> ,
			checked : false ,
			required : true ,
		} ,

		{
			text: Terms.MARKETING,
			content: null,
			checked: false,
			required: false,
		},
	]

	const [doCheckAll, setDoCheckAll] = useState(false);
	const [doRequiredCheck, setDoRequiredCheck] = useState(false);
	const [policyList, setPolicyList] = useState(initialState)


	useEffect(() => {
		// 체크박스가 하나라도 false 이면 전체 동의 체크 false 처리
		setDoCheckAll(  ( policyList.find( ( p ) => p.checked === false ) ? false : true )   );

		// 회원가입 Form 에 담아 부모 컴포넌트로 보냄. -> 다른 자식 컴포넌트인 JoinForm 에서 사용될 데이터.
		const newData = policyList.map(v => ({
			term : v.text ,
			status : v.checked
		}))

		let newList = [];

		// 필수 항목 체크 여부 확인
		policyList.forEach(v => {
			if(v.required) return newList.push(v)
		})
	

		// 필수 항목 체크 완료에 따라 다음 버튼 disable 토글
		if(newList.find(v => v.checked !== true)) {
			setDoRequiredCheck(false)
		} else {
			setCheckPolicy(newData)
			setDoRequiredCheck(true)
		}
	}, [policyList])


	const handleCheckAll = useCallback(() => {
		const value = policyList.map((v) => ({
			...v ,
			checked : !doCheckAll
		}))

		setDoCheckAll(!doCheckAll)
		setPolicyList(value)

	}, [policyList , doCheckAll]) 

    const { t } = useTranslation();

	return (
		<div className="join-policy-wrap">
			<div className="join-auth-all">
				<div className="checkbox">
					<label className={`checkbox-custom`}>
						<input type="checkbox" checked={doCheckAll} onChange={handleCheckAll} />
						<span className="checkmark" />
						<span className="checkbox-label join-chk">{t("pages.auth.JoinPage.Contents.JoinPolicy.allChecked")}</span>
					</label>
				</div>
			</div>
			{policyList.map((pol, p_index) => (
				<div className="join-auth-wrap" key={p_index}>
					<div className="checkbox">
						<label className={`checkbox-custom`}>
							<input 
								type="checkbox"
								checked={pol.checked}
								onChange={() => {
									const value = policyList.map((policy, idx) => 
										p_index === idx? {...policy, checked : !pol.checked} : policy
									)
									setPolicyList(value)
								}}
							/>
							<span className="checkmark" />
							<span className="checkbox-label join-chk">
								{pol.text} <b>({pol.required ? t("pages.auth.JoinPage.Contents.JoinPolicy.require") : t("pages.auth.JoinPage.Contents.JoinPolicy.option")})</b>
							</span>
						</label>
					</div>
					{pol.content !== null && <div className="article">{pol.content}</div>}
				</div>
			))}
		
			<div className="btn-wrap">
				<button 
					className="btn__solid" 
					color="gray"
					onClick={() => navigate('/')}
				>
					{t("pages.auth.JoinPage.Contents.JoinPolicy.prev")}
				</button>
				<button 
					className="btn__solid" 
					color="primary"
				 	disabled={!doRequiredCheck}
					onClick={() => setCurrentStep("joinForm")}
				>
					{t("pages.auth.JoinPage.Contents.JoinPolicy.next")}
				</button>
			</div>
		</div>
	);
};

export default JoinPolicy;
